<template>
  <div id="config-adjustments-wrapper">
    <item-tile
      v-for="(item, index) in adjustments"
      :key="index"
      class="adjustment-item"
      :heading="item.name"
      :selected="true"
      :secondaryIcons="['pencil']"
      @primary-icon-clicked="initiateDelete(item, index)"
      @secondary-icon-clicked="initiateEdit(item, index)"
    />
    <item-tile
      class="adjustment-item"
      :selected="false"
      heading="Add New Adjustment"
      @click="toggleCreationActive"
    />
    <adjustment-creation
      v-if="creationActive"
      :adjustment="edit.adjustment"
      @close="toggleCreationActive"
      @add-adjustment="callDb"
    />
    <adjustment-delete
      v-if="del.adjustment"
      :subject="del.adjustment"
      :processing="del.processing"
      @close="closeDelete"
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import AdjustmentCreation from "./Modals/Adjustments/AdjustmentCreation.vue";
import AdjustmentDelete from "./Modals/Adjustments/Delete.vue";
import ItemTile from "@/Components/UI/ItemTile.vue";
export default {
  data() {
    return {
      creationActive: false,
      deleteActive: false,
      edit: {
        adjustment: undefined,
        index: undefined,
      },
      del: {
        processing: false,
        adjustment: undefined,
        index: undefined,
      },
    };
  },
  computed: {
    adjustments() {
      return this.$store.getters.adjustments;
    },
  },
  methods: {
    toggleCreationActive() {
      this.edit = {
        index: undefined,
        adjustment: undefined,
      };
      this.creationActive = !this.creationActive;
    },
    initiateEdit(item, index) {
      this.toggleCreationActive();
      this.edit.adjustment = item;
      this.edit.index = index;
    },
    initiateDelete(item, index) {
      this.del.adjustment = item;
      this.del.index = index;
    },
    closeDelete() {
      this.del = {
        processing: false,
        adjustment: undefined,
        index: undefined,
      };
    },
    async confirmDelete() {
      this.del.processing = true;
      await this.$store.dispatch("updateConfig", {
        key: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
        index: this.del.index,
        category: "adjustments",
        operation: "delete",
        api_version: this.$store.state.businessSettings.api_version,
      });
      this.closeDelete();
    },
    async callDb(subject) {
      let updatePacket = {
        key: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
        subject: subject,
        category: "adjustments",
        api_version: this.$store.state.businessSettings.api_version,
      };
      if (this.edit.index) {
        updatePacket = {
          ...updatePacket,
          index: this.edit.index,
          operation: "edit",
        };
      } else {
        updatePacket = {
          ...updatePacket,
          operation: "add",
        };
      }
      await this.$store.dispatch("updateConfig", updatePacket);
      this.toggleCreationActive();
    },
  },
  created() {},
  components: {
    ItemTile,
    AdjustmentCreation,
    AdjustmentDelete,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #config-adjustments-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-items: flex-start;
    box-sizing: border-box;
  }

  .adjustment-item {
    margin: 20px;
    background-color: var(--secondaryColor);
  }
  @media (min-width: 800px) {
    .adjustment-item {
      margin: 30px;
    }
  }
}
</style>
